import { cva, type VariantProps } from 'class-variance-authority'
import { Popover as PopoverPrimitive } from 'radix-ui'
import * as React from 'react'

import { cn } from '@/legacy-src/lib/utils'

// TODO: Not shadcn component, it implements tooltip using popover, it needs to reworked

const Tooltip = PopoverPrimitive.Root

const tooltipTriggerVariants = cva(
  'ml-2 flex h-[20px] w-[20px] items-center justify-center rounded-full border-transparent p-0 font-sans text-sm font-bold shadow-none focus:outline-none focus:ring-2 focus:ring-offset-2',
  {
    variants: {
      variant: {
        light: 'bg-blue-500 text-secondary hover:bg-petrol-300 hover:text-white focus:ring-blue-500',
        dark: 'bg-petrol-500 text-white hover:bg-petrol-400 hover:text-secondary focus:ring-petrol-500',
      },
    },
    defaultVariants: { variant: 'light' },
  },
)

export interface TooltipTriggerProps
  extends React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Trigger>,
    VariantProps<typeof tooltipTriggerVariants> {}

const TooltipTrigger = React.forwardRef<React.ElementRef<typeof PopoverPrimitive.Trigger>, TooltipTriggerProps>(
  ({ className, variant, ...props }, ref) => (
    <PopoverPrimitive.Trigger ref={ref} className={cn(tooltipTriggerVariants({ variant, className }))} {...props} />
  ),
)
TooltipTrigger.displayName = PopoverPrimitive.Trigger.displayName

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'text-primary-foreground z-[2147483633] max-w-[300px] origin-[--radix-popover-content-transform-origin] overflow-hidden rounded-md bg-yellow-400 px-3 py-1.5 text-center text-xs animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
TooltipContent.displayName = PopoverPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent }
